import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceModel } from "../../models/device.model";
import { DeviceService } from "../../services/device.service";

@Component({
    selector: 'device-info',
    templateUrl: './device-info.component.html',
    styleUrls: ['./device-info.component.css']
})
export class DeviceInfoComponent {

    constructor(private router: Router, private deviceService: DeviceService) {}
    private checked = false;
    @Input() deviceModel: DeviceModel;

    switchDevice(busIdentifier: string): void {
        this.deviceService.switchDevice(busIdentifier)
        .subscribe(response => {            
            //location.reload();
            this.deviceModel.value = this.deviceModel.value == "0" ? "1" : "0";
            this.deviceModel.checked = this.deviceModel.value == "0" ? false : true;
            this.checked = this.deviceModel.value == "0" ? false : true;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/device-info/device-info.component.ts